"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Price } from "@/components/Price/Price.component";
import { Spinner } from "@/components/Spinner/Spinner.component";
import { Translation } from "@/components/Translation/Translation.component";
import { useProductCountryVat } from "@/contexts/products/product-country-vat.context";
import type { ProductModel } from "@/services/api/shop/models/product.model";
import { captureClientException } from "@/services/logging/capture-client-exception";
type QuarterlyProductMinimumPriceProps = {
  readonly product: ProductModel;
  readonly isVatCalculationEnabled: boolean;
};
export function QuarterlyProductMinimumPrice(t0) {
  const $ = _c(15);
  const {
    product,
    isVatCalculationEnabled
  } = t0;
  const {
    currency
  } = product;
  const [price, setPrice] = useState(isVatCalculationEnabled ? null : product.price);
  const {
    countryCode,
    getPriceWithVat,
    isPending
  } = useProductCountryVat();
  let t1;
  let t2;
  if ($[0] !== countryCode || $[1] !== getPriceWithVat || $[2] !== isVatCalculationEnabled || $[3] !== product) {
    t1 = () => {
      if (countryCode === null || product === null || !isVatCalculationEnabled) {
        return;
      }
      getPriceWithVat(product).then(setPrice).catch(captureClientException);
    };
    t2 = [countryCode, product, getPriceWithVat, isVatCalculationEnabled];
    $[0] = countryCode;
    $[1] = getPriceWithVat;
    $[2] = isVatCalculationEnabled;
    $[3] = product;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (isPending || price === null) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Spinner className="inline-block h-2 w-2 rounded-full fill-primary text-whisper" />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== currency || $[8] !== price) {
    t3 = <Price currency={currency} price={price} />;
    $[7] = currency;
    $[8] = price;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isVatCalculationEnabled) {
    t4 = isVatCalculationEnabled ? <Translation da="inkl. moms" de="inkl. MwSt." en="incl. VAT" no="inkl. mva." sv="inkl. moms" /> : <Translation da="ekskl. moms" de="exkl. MwSt." en="excl. VAT" no="eks. mva." sv="exkl. moms" />;
    $[10] = isVatCalculationEnabled;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <span className="inline-flex gap-0.5">{t3}{" "}{t4}</span>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}